import React, { useEffect, useState } from "react";

interface StatementProps {
  className?: string;
}

const Statement: React.FC<StatementProps> = ({ className }) => {
  return (
    <div className="mt-6 rounded-lg border border-yellow-300 bg-yellow-100 p-4">
      <h4 className="mb-2 font-bold text-yellow-800">
        <i className="fas fa-exclamation-circle mr-2"></i>Special Weather
        Statement
      </h4>
      <p className="text-yellow-700">
        The weather will continue to be terrible for the foreseeable future.
        Consider moving to a different planet. Our meteorologists suggest
        staying indoors and embracing seasonal depression.
      </p>
    </div>
  );
};

export default Statement;
